<template>
    <div class="layout-header">
        <div class="header-nav">
            <img src="../../assets/images/navitas_logo_white.png" alt="Navitas Safety">
            <nav-link v-for="(navItem, key) in navItems" :name="navItem.name" :path="navItem.path"
                      :icon-name="navItem.iconName" v-bind:key="key"/>
        </div>
        <div class="nav-link" @click="actionLogout">
            <img src="../../assets/images/circlehead.png" alt="Navitas Safety">
            <span>Logout</span>
        </div>
    </div>
</template>

<script>
    import NavLink from "./NavLink";
    import navItems from "../../js/navItems";
    import AuthService from "../../new/services/AuthService";

    export default {
        name: "LayoutHeader",
        components: {NavLink},
        computed: {
            navItems() {
                return navItems.filter(i => {
                    return this.checkScope(i.scope)
                });
            }
        },
        methods: {
            actionLogout() {
                this.$bus.emit('logout')
            },
            checkScope(scope) {
                const parseJwt = (token) => {
                    try {
                        return JSON.parse(atob(token.split('.')[1]));
                    } catch (e) {
                        return null;
                    }
                };

                if (scope == null) {
                    return true;
                }

                const jwt = parseJwt(AuthService.getAccessToken());

                if (jwt.scopes) {
                    return jwt.scopes.includes(scope);
                }
                return false;
            }
        }
    }
</script>